import React from 'react';
import update from 'immutability-helper';
import {
  Draggable,
  Droppable,
  DropResult,
  DragDropContext,
} from 'react-beautiful-dnd';

import { Icon } from 'common/icon';

import { Props } from './types';
import { Container, ImageContainer, RemoveButton } from './styles';

// To test drag and drop locally - remove React.StrictMode

export const HorizontalImagesList = ({ images, onChange, onRemove }: Props) => {
  const uris = React.useMemo(() => {
    return images
      .map((item) => {
        if (item.file) return URL.createObjectURL(item.file);
        return item.original ?? '';
      })
      .filter((item) => !!item);
  }, [images]);

  React.useEffect(() => {
    return () => {
      if (uris.length > 0) {
        uris.forEach((item) => {
          URL.revokeObjectURL(item);
        });
      }
    };
  }, [uris]);

  const handleDragEnd = React.useCallback(
    (result: DropResult) => {
      if (!result.destination) {
        return;
      }

      const startIndex = result.source.index;
      const endIndex = result.destination.index;

      if (startIndex !== endIndex && onChange) {
        onChange(
          update(images, {
            $splice: [
              [startIndex, 1],
              [endIndex, 0, images[startIndex]],
            ],
          })
        );
      }
    },
    [onChange, images]
  );

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(droppableProps) => (
          <Container
            ref={droppableProps.innerRef}
            {...droppableProps.droppableProps}
          >
            {uris.map((uri, index) => {
              return (
                <Draggable index={index} key={uri} draggableId={uri}>
                  {(draggableProps) => {
                    return (
                      <ImageContainer
                        ref={draggableProps.innerRef}
                        {...draggableProps.draggableProps}
                        {...draggableProps.dragHandleProps}
                      >
                        <img src={uri} />
                        <RemoveButton
                          type="button"
                          onClick={() => onRemove(index)}
                        >
                          <Icon icon="cross" />
                        </RemoveButton>
                      </ImageContainer>
                    );
                  }}
                </Draggable>
              );
            })}
            {droppableProps.placeholder}
          </Container>
        )}
      </Droppable>
    </DragDropContext>
  );
};
